import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { DocumentTemplateForm, DocumentTemplateFormValues } from "./DocumentTemplateForm";
import { DocumentTemplatePageApi, documentTemplatesApi } from "api";
import { routes } from "consts";
import { useToaster } from "utils";
import { useDocumentTemplate } from "api/hooks";
import { PageFormValues, PagePlaceholdersForm } from "./PagePlaceholdersForm";
import { PaziaBreadcrumbs } from "components/atoms";
import { DocumentPagesTabs } from "./DocumentPagesTabs";

interface Page {
  key: string;
  title: string;
  page: DocumentTemplatePageApi | null;
}
export const PageDocumentAddPage = () => {
  const { documentTemplateId } = useParams();
  const [processing, setProcessing] = React.useState(false);
  const { showSuccess, showError } = useToaster();
  const { data, loading, refresh } = useDocumentTemplate(Number(documentTemplateId));
  const [pages, setPages] = React.useState<Page[]>([]);

  useEffect(() => {
    if (!data || !data.pages) return;
    const pages: Page[] = [{ key: "-1", title: "Dane podstawowe", page: null }];
    pages.push(
      ...data.pages.map((page) => ({ key: page.pageId.toString(), title: `Strona ${page.pageNumber}`, page }))
    );
    setPages(pages);
  }, [data]);

  const [activePage, setActivePage] = React.useState<number>(0);

  const onAddPage = () => {
    setPages([...pages, { key: "0", page: defaultPage, title: `Strona ${pages.length}` }]);
    setActivePage(pages.length);
  };

  if (!data) return null;

  const breadcrumbs = [{ title: "Szablony dokumentów", path: routes.DOCUMENTS }, { title: data.name }];

  const onSubmit = async (pageData: PageFormValues) => {
    try {
      const maxPageNumber = Math.max(...data.pages.map((x) => x.pageNumber), 0);
      const request = { ...pageData, pageNumber: maxPageNumber + 1 };
      if (request.pageId) {
        await documentTemplatesApi.updatePage(data.id, request.pageId, request);
        showSuccess(`Zaktualizowano stronę`);
      } else {
        await documentTemplatesApi.createPage(data.id, request);
        showSuccess(`Utworzono stronę`);
      }
      refresh();
    } catch (e) {
      showError("Nie udało się zapisać strony");
    }
  };

  const onEditSubmit = async (editData: DocumentTemplateFormValues) => {
    await documentTemplatesApi.update(Number(documentTemplateId), editData);
    showSuccess(`Zaktualizowano dokument`);
  };

  const removePage = async (pageId: number) => {
    try {
      if (pageId) {
        await documentTemplatesApi.deletePage(data.id, pageId);
        showSuccess(`Usunięto stronę`);
        refresh();
      } else {
        setPages(pages.filter((x) => x.key != pageId + ""));
      }
      setActivePage(0);
    } catch {
      showError(`Nie udało się usunąć strony`);
    }
  };

  return (
    <>
      <div className="p-2">
        <PaziaBreadcrumbs segments={breadcrumbs} />
      </div>
      <div className="w-2/5">
        <div className="flex flex-col bg-white dark:bg-slate-800 " style={{ height: "calc(100vh - 104px)" }}>
          <DocumentPagesTabs pages={pages} activePage={activePage} onTabClick={setActivePage} onAddTab={onAddPage} />
          {pages.map((page, index) => {
            if (page.key == "-1")
              return (
                <DocumentTemplateForm
                  key={page.key}
                  onSubmit={onEditSubmit}
                  template={data}
                  className={activePage === index ? "" : "hidden"}
                />
              );
            if (page.page == null) return null;
            return (
              <PagePlaceholdersForm
                key={page.key}
                formClassName={activePage === index ? "" : "hidden"}
                documentTemplateId={Number(documentTemplateId)}
                templateName={data.name}
                height={data.height}
                width={data.width}
                page={page.page}
                onSubmit={onSubmit}
                onRemove={removePage}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

const defaultPage: DocumentTemplatePageApi = {
  placeholders: [],
  pageId: 0,
  pageNumber: 1,
  background: "",
};
